import { type Ref, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { onClickOutside } from '@vueuse/core'

import {
    type TooltipCustom,
    useTooltipStore,
} from '@/directives/tooltip/tooltip'
import type { TooltipFragment } from '@/graphql/api'

export function useTooltip(): {
    tooltip: Ref<TooltipFragment | TooltipCustom | null>
    close: () => void
    open: (t: TooltipFragment | TooltipCustom, triggerEl: HTMLElement) => void
    tooltipEl: Ref<HTMLElement | null>
} {
    const tooltipStore = useTooltipStore()
    const { close, open } = tooltipStore
    const { tooltip, triggerElement } = storeToRefs(tooltipStore)

    const tooltipEl = ref<HTMLElement | null>(null)

    onClickOutside(tooltipEl, close, { ignore: [triggerElement] })

    return {
        tooltip,
        close,
        open,
        tooltipEl,
    }
}
